export const ADD_WISH = 'inc/wish'
export const REMOVE_WISH = 'decr/wish'
export const RESET_WISH = 'reset/wish'